import { SortableHeader, SortableHeadersGroup } from 'components/Shared';
import type { PaginatedDocument } from 'contracts/Documents';
import { SortingParams } from 'contracts/Common';
import React, { useCallback } from 'react';
import * as S from './styles';
import { useMutation } from 'react-query';
import { useDocument } from 'hooks/api/document';
import { useAuth } from 'hooks';

interface Props {
  documents: PaginatedDocument[];
  onSort?: (sort: SortingParams) => void;
  currentSort: SortingParams;
}

interface ItemProps {
  document: PaginatedDocument;
  loading?: boolean;
  onDownloadClick: (id: number) => void;
}

export const DocumentsList: React.FC<Props> = ({
  documents,
  onSort,
  currentSort,
}) => {
  const { downloadDocument } = useDocument();
  const { userBelongsToAnyOf } = useAuth();

  const mutationDownload = useMutation({
    mutationFn: downloadDocument,
  });

  const Item = useCallback(
    ({ document, onDownloadClick, loading }: ItemProps): JSX.Element => {
      const { id, category, description, fileName } = document;

      return (
        <S.ListItem>
          <S.Column>{id}</S.Column>
          <S.Column title={fileName}>{fileName}</S.Column>
          <S.Column title={category}>{category}</S.Column>
          <S.Column title={description}>{description}</S.Column>
          <S.ActionsColumn>
            <S.DownloadButton
              onClick={(e) => {
                e.stopPropagation();
                onDownloadClick(id);
              }}
              disabled={loading}
              title="Baixar Arquivo"
            >
              <S.DownloadIcon />
            </S.DownloadButton>
            {userBelongsToAnyOf('admin') ? (
              <S.LinkActionButton
                to={`/documentacoes/${id}/editar`}
                title="Editar"
              >
                <S.EditIcon />
              </S.LinkActionButton>
            ) : (
              <></>
            )}
          </S.ActionsColumn>
        </S.ListItem>
      );
    },
    []
  );

  return (
    <S.List>
      <S.ListHeader>
        <SortableHeadersGroup onSort={onSort} currentSort={currentSort}>
          <SortableHeader column="id" label="ID" />
          <SortableHeader column="fileName" label="ARQUIVO" />
          <SortableHeader column="category" label="CATEGORIA" />
          <SortableHeader column="description" label="DESCRIÇÃO" />
        </SortableHeadersGroup>
      </S.ListHeader>
      {documents.map((document) => (
        <Item
          key={document.id}
          document={document}
          onDownloadClick={mutationDownload.mutate}
          loading={
            document.id === mutationDownload.variables &&
            mutationDownload.isLoading
          }
        />
      ))}
    </S.List>
  );
};
